// src/Components/Loading.js
import React, { useEffect, useState } from "react";
import "./Loading.css";
import logoLipe from "../Assets/logo_lipe.png";
import useLoading from "../Hooks/useLoading";

const BOOT_MAX_MS = 6000;

export default function Loading() {
  const { loading } = useLoading();
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    let released = false;

    const release = () => {
      if (released) return;
      released = true;
      setBooting(false);
    };

    if (document.readyState === "complete") {
      release();
    } else {
      window.addEventListener("load", release, { once: true });
    }

    // Fallback: se o `load` nunca disparar, libera depois de BOOT_MAX_MS
    const fallback = setTimeout(release, BOOT_MAX_MS);

    return () => {
      window.removeEventListener("load", release);
      clearTimeout(fallback);
    };
  }, []);

  if (!loading && !booting) return null;

  return (
    <div className="loading-overlay" role="status" aria-live="polite">
      <div className="loading-box">
        <div className="loading-ring">
          <div className="loading-glow" />
          <div className="loading-logo-wrap">
            <img src={logoLipe} alt="" className="loading-logo" />
          </div>
        </div>
        <span className="loading-text">
          {booting && !loading ? "Preparando…" : "Carregando…"}
        </span>
      </div>
    </div>
  );
}